import React from "react";

// core components
import NavbarPaginaInicial from "./Navbars/NavbarPaginaInicial.js";

// index page sections
import Hero from "./IndexSections/Hero.js";

class Home extends React.Component {
    componentDidMount() {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.refs.main.scrollTop = 0;
    }
    render() {
        return (
            <>
                <NavbarPaginaInicial />
                <main ref="main">
                    <Hero />
                </main>

            </>
        );
    }
}

export default Home;
